export default "__VITE_ASSET__D7_RjxUV__"